import React from "react";
import { Box, Stack, Typography, FormControl, Select, MenuItem } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import { MONTHS, YEARS } from "../constants";

export default function CertificadosHeader({ month, year, onMonthChange, onYearChange }) {
  return (
    <Box
      className="no-print"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "stretch", md: "center" },
        justifyContent: "space-between",
        gap: 2.5,
        pb: 3,
        borderBottom: "1px solid #e8eaef",
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            bgcolor: "#eef5fd",
            color: "#1975d1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <VerifiedIcon sx={{ fontSize: 22 }} />
        </Box>
        <Box>
          <Typography
            variant="h5"
            sx={{ fontWeight: 700, color: "#111827", letterSpacing: "-0.02em", lineHeight: 1.2 }}
          >
            Certificados
          </Typography>
          <Typography variant="body2" sx={{ color: "#9ca3af", mt: 0.25 }}>
            Emisión de certificados de servicios con reporte de plagas
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={1.5} sx={{ flexShrink: 0 }}>
        <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 140 } }}>
          <Select value={month} onChange={(e) => onMonthChange(Number(e.target.value))} sx={selectSx}>
            {MONTHS.map((m, i) => (
              <MenuItem key={m} value={i + 1}>
                {m}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" sx={{ minWidth: { xs: "100%", sm: 96 } }}>
          <Select value={year} onChange={(e) => onYearChange(Number(e.target.value))} sx={selectSx}>
            {YEARS.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>
    </Box>
  );
}

const selectSx = {
  borderRadius: "10px",
  bgcolor: "#fff",
  fontSize: "0.875rem",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e8eaef" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#d1d5db" },
};
